import { useFormContext, UseFormReturn } from 'react-hook-form';

import { AppError } from '@/utils';

import { GlobalLetterForm } from './use-global-letter.form';

export const useGlobalLetterFormContext = ():
  | UseFormReturn<GlobalLetterForm>
  | never => {
  const form = useFormContext<GlobalLetterForm>();

  if (form === null)
    throw AppError.hookScopeError('useGlobalLetterFormContext error.');

  return form;
};
